import api from '@/api/surveillance'
import surveillance from '@/sui/data/surveillance'
import ice from '@/sui/tools/ice'

import moment from 'moment'

const state = function () {
  return {
    all: {
      '2019': [],
      '2020': [],
      '2021': [],
      '2022': [],
      '2023': [],
      '2024': [],
      '2025': [],
      '2026': []
    },
    surveys: []
  }
}

function callThenLoadAll (f) {
  return ({ commit, dispatch }, request) => {
    return api[f](request).then(
      (r) => {
        if (r.data.err == null) {
          dispatch('all', request.year)
        }
        return r
      }
    )
  }
}

// getters
const getters = {
  listByName: (state) => (year) => {
    const result = []
    state.all[year].forEach(
      (s) => {
        result.push(
          {
            surveillance: s,
            value: `${s.establishment.name} (${s.establishment.finess})`
          }
        )
      }
    )
    return result
  }
}

// actions
const actions = {
  all ({ commit }, year) {
    return api[`all${year}`]().then((response) => {
      commit(`setAll${year}`, response.data.v)
      return response
    })
  },

  allSurveys ({ commit }) {
    return api.surveys({ t: 'surveillance2019' }).then((response) => {
      if (response.data.err == null) {
        commit('setSurveys', response.data.v)
      }
      return response
    })
  },

  uploadConvention ({ state, dispatch }, request) {
    return api.uploadConvention(
      request.progress,
      request.data
    ).then((response) => {
      if (response.data.err == null) {
        dispatch('all', request.year)
      }
      return response
    })
  },

  acceptConvention: callThenLoadAll('acceptConvention'),
  refuseConvention: callThenLoadAll('refuseConvention'),

  downloadConvention (_, request) {
    return api.downloadConvention(request)
  },

  getConventionHistory (_, request) {
    return api.getConventionHistory(request)
  },

  remove (_, request) {
    if (request.y === 2019) {
      return api.remove2019(request.i)
    }
    return api.remove(request.i)
  },

  updateSubscription ({ dispatch }, request) {
    const r = surveillance.updateRequest(request)
    const y = request.target.year
    const msg = `updateSubscription${y === 2019 ? y : ''}`
    return api[msg](r).then((response) => {
      if (response.data.err == null) {
        dispatch('all', y)
      }
      return response
    })
  },

  updateReferent: callThenLoadAll('updateReferent'),
  updateRegistrator: callThenLoadAll('updateRegistrator'),
  updateEstablishment: callThenLoadAll('updateEstablishment'),

  updateReaExplaurStatus: callThenLoadAll('updateReaExplaurStatus'),
  setExplaurSwabStatus: callThenLoadAll('setExplaurSwabStatus'),
  updateReaSinkStatus ({ dispatch }, request) {
    return api.updateReaSinkStatus(request).then((response) => {
      if (response.data.err == null) {
        dispatch('all', 2020)
      }
      return response
    })
  },

  updateWaterPoints ({ dispatch }, request) {
    return api.updateWaterPoints(request).then((response) => {
      if (response.data.err == null) {
        dispatch('all', 2020)
      }
      return response
    })
  },

  updateDataset: callThenLoadAll('updateDataset'),
  updateDatasetSheets: callThenLoadAll('updateDatasetSheets'),
  updateDatasetDenominators: callThenLoadAll('updateDatasetDenominators'),

  getDatasetSheets (_, request) {
    return api.getDatasetSheets(request)
  },

  getDatasetDenominators (_, request) {
    return api.getDatasetDenominators(request)
  },

  migrate: function () {
    return api.migrate()
  },

  o4dataset2020: function () {
    return api.o4dataset2020()
  }
}

function setAll (state, all, year) {
  const result = []
  all.forEach(
    (s) => {
      let c = surveillance.serverToClient(s)
      c = surveillance.addMethods(c)
      c.fillAvalaibleModules(c.registrator.id)
      result.push(c)
    }
  )
  state.all[year] = ice.freeze(result)
}

// mutations
const mutations = {
  setAll2019 (state, all) {
    setAll(state, all, '2019')
  },

  setAll2020 (state, all) {
    setAll(state, all, '2020')
  },

  setAll2021 (state, all) {
    setAll(state, all, '2021')
  },

  setAll2022 (state, all) {
    setAll(state, all, '2022')
  },

  setAll2023 (state, all) {
    setAll(state, all, '2023')
  },

  setAll2024 (state, all) {
    setAll(state, all, '2024')
  },

  setAll2025 (state, all) {
    setAll(state, all, '2025')
  },

  setAll2026 (state, all) {
    setAll(state, all, '2026')
  },

  setSingleSheetStatus (state, request) {
    const y = `${request.year}`
    const surveillance = state.all[y].find(s => s.id === request.id)
    if (surveillance == null) {
      return
    }
    surveillance[request.type].shst = request.st
  },

  setSurveys (state, surveys) {
    const result = []
    surveys.forEach(
      s => {
        const line = {
          id: s._key,
          userid: s.u,
          date: moment(s.d)
        }

        s.r.forEach(
          r => {
            line[r.k] = r.v
          }
        )
        s.c.forEach(
          r => {
            line[r.k] = decodeURIComponent(atob(r.v))
          }
        )
        line.hasC = line.comment.length > 0
        line.hasE = line.evolution.length > 0
        result.push(line)
      }
    )
    state.surveys = Object.freeze(result)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations

}
